/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LearnerRouteImport } from './routes/_learner'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminTeachersRouteImport } from './routes/admin.teachers'
import { Route as AdminSubjectsRouteImport } from './routes/admin.subjects'
import { Route as AdminStudentsRouteImport } from './routes/admin.students'
import { Route as AdminMarkSchemesRouteImport } from './routes/admin.mark-schemes'
import { Route as AdminGbReportCardsRouteImport } from './routes/admin.gb-report-cards'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'
import { Route as AdminCoursesRouteImport } from './routes/admin.courses'
import { Route as AdminCalendarRouteImport } from './routes/admin.calendar'
import { Route as AdminAwardsRouteImport } from './routes/admin.awards'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as AdminAccountRouteImport } from './routes/admin.account'
import { Route as LearnerProgressRouteImport } from './routes/_learner.progress'
import { Route as LearnerProfileRouteImport } from './routes/_learner.profile'
import { Route as LearnerMentionsRouteImport } from './routes/_learner.mentions'
import { Route as LearnerHomeworksRouteImport } from './routes/_learner.homeworks'
import { Route as LearnerCoursesRouteImport } from './routes/_learner.courses'
import { Route as LearnerCalendarRouteImport } from './routes/_learner.calendar'
import { Route as LearnerAwardsRouteImport } from './routes/_learner.awards'
import { Route as LearnerAnnouncementsRouteImport } from './routes/_learner.announcements'
import { Route as LearnerAccountRouteImport } from './routes/_learner.account'
import { Route as LearnerProfileIndexRouteImport } from './routes/_learner.profile.index'
import { Route as AdminGbReportCardsIdRouteImport } from './routes/admin.gb-report-cards_.$id'
import { Route as AdminCoursesIdRouteImport } from './routes/admin.courses_.$id'
import { Route as LearnerProfileAccountRouteImport } from './routes/_learner.profile.account'
import { Route as LearnerHomeworksIdRouteImport } from './routes/_learner.homeworks_.$id'
import { Route as LearnerCoursesIdRouteImport } from './routes/_learner.courses_.$id'
import { Route as LearnerAnnouncementsIdRouteImport } from './routes/_learner.announcements_.$id'
import { Route as AdminCoursesIdIndexRouteImport } from './routes/admin.courses_.$id.index'
import { Route as LearnerHomeworksIdIndexRouteImport } from './routes/_learner.homeworks_.$id.index'
import { Route as LearnerCoursesIdIndexRouteImport } from './routes/_learner.courses_.$id.index'
import { Route as AdminGbReportCardsIdPrintRouteImport } from './routes/admin.gb-report-cards_.$id_.print'
import { Route as AdminCoursesIdTeachersRouteImport } from './routes/admin.courses_.$id.teachers'
import { Route as AdminCoursesIdSettingsRouteImport } from './routes/admin.courses_.$id.settings'
import { Route as AdminCoursesIdRubricsRouteImport } from './routes/admin.courses_.$id.rubrics'
import { Route as AdminCoursesIdQuizzesRouteImport } from './routes/admin.courses_.$id.quizzes'
import { Route as AdminCoursesIdQuestionsRouteImport } from './routes/admin.courses_.$id.questions'
import { Route as AdminCoursesIdInfoRouteImport } from './routes/admin.courses_.$id.info'
import { Route as AdminCoursesIdHomeworksRouteImport } from './routes/admin.courses_.$id.homeworks'
import { Route as AdminCoursesIdGradebookRouteImport } from './routes/admin.courses_.$id.gradebook'
import { Route as AdminCoursesIdEnrollmentsRouteImport } from './routes/admin.courses_.$id.enrollments'
import { Route as AdminCoursesIdCurriculumRouteImport } from './routes/admin.courses_.$id.curriculum'
import { Route as AdminCoursesIdAwardsRouteImport } from './routes/admin.courses_.$id.awards'
import { Route as AdminCoursesIdAttendanceRouteImport } from './routes/admin.courses_.$id.attendance'
import { Route as AdminCoursesIdAssessmentsRouteImport } from './routes/admin.courses_.$id.assessments'
import { Route as LearnerCoursesIdSurveysRouteImport } from './routes/_learner.courses_.$id.surveys'
import { Route as LearnerCoursesIdSelfAssessmentsRouteImport } from './routes/_learner.courses_.$id.self-assessments'
import { Route as LearnerCoursesIdQuizzesRouteImport } from './routes/_learner.courses_.$id.quizzes'
import { Route as LearnerCoursesIdMyProgressRouteImport } from './routes/_learner.courses_.$id.my-progress'
import { Route as LearnerCoursesIdGradesRouteImport } from './routes/_learner.courses_.$id.grades'
import { Route as LearnerCoursesIdFeedRouteImport } from './routes/_learner.courses_.$id.feed'
import { Route as LearnerCoursesIdContentRouteImport } from './routes/_learner.courses_.$id.content'
import { Route as LearnerCoursesIdClassProgressRouteImport } from './routes/_learner.courses_.$id.class-progress'
import { Route as LearnerCoursesIdCalendarRouteImport } from './routes/_learner.courses_.$id.calendar'
import { Route as LearnerCoursesIdAttendanceRouteImport } from './routes/_learner.courses_.$id.attendance'
import { Route as LearnerCoursesIdAssignmentsRouteImport } from './routes/_learner.courses_.$id.assignments'
import { Route as LearnerCoursesIdAboutRouteImport } from './routes/_learner.courses_.$id.about'
import { Route as LearnerAwardsIdCertificateRouteImport } from './routes/_learner.awards_.$id.certificate'
import { Route as LearnerCoursesIdQuizzesIndexRouteImport } from './routes/_learner.courses_.$id.quizzes.index'
import { Route as LearnerCoursesIdClassProgressIndexRouteImport } from './routes/_learner.courses_.$id.class-progress.index'
import { Route as LearnerHomeworksIdSubmissionsSidRouteImport } from './routes/_learner.homeworks_.$id.submissions.$sid'
import { Route as LearnerCoursesIdQuizzesQuizIdRouteImport } from './routes/_learner.courses_.$id.quizzes.$quizId'
import { Route as LearnerCoursesIdQuizzesQuizIdIndexRouteImport } from './routes/_learner.courses_.$id.quizzes.$quizId.index'
import { Route as AdminCoursesIdQuizzesQuizIdStatisticsRouteImport } from './routes/admin.courses_.$id.quizzes_.$quizId.statistics'
import { Route as AdminCoursesIdQuizzesQuizIdEditRouteImport } from './routes/admin.courses_.$id.quizzes_.$quizId.edit'
import { Route as AdminCoursesIdAssessmentsQuizIdEditRouteImport } from './routes/admin.courses_.$id.assessments_.$quizId.edit'
import { Route as LearnerCoursesIdClassProgressStudentsStudentIdRouteImport } from './routes/_learner.courses_.$id.class-progress.students.$studentId'
import { Route as LearnerCoursesIdQuizzesQuizIdAttemptsIndexRouteImport } from './routes/_learner.courses_.$id.quizzes.$quizId.attempts.index'
import { Route as LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRouteImport } from './routes/_learner.courses_.$id.quizzes.$quizId.grade.$attemptId'
import { Route as LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRouteImport } from './routes/_learner.courses_.$id.quizzes.$quizId.attempts.$attemptId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnerRoute = LearnerRouteImport.update({
  id: '/_learner',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTeachersRoute = AdminTeachersRouteImport.update({
  id: '/teachers',
  path: '/teachers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSubjectsRoute = AdminSubjectsRouteImport.update({
  id: '/subjects',
  path: '/subjects',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentsRoute = AdminStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMarkSchemesRoute = AdminMarkSchemesRouteImport.update({
  id: '/mark-schemes',
  path: '/mark-schemes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGbReportCardsRoute = AdminGbReportCardsRouteImport.update({
  id: '/gb-report-cards',
  path: '/gb-report-cards',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoursesRoute = AdminCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCalendarRoute = AdminCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAwardsRoute = AdminAwardsRouteImport.update({
  id: '/awards',
  path: '/awards',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccountRoute = AdminAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AdminRoute,
} as any)
const LearnerProgressRoute = LearnerProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerProfileRoute = LearnerProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerMentionsRoute = LearnerMentionsRouteImport.update({
  id: '/mentions',
  path: '/mentions',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerHomeworksRoute = LearnerHomeworksRouteImport.update({
  id: '/homeworks',
  path: '/homeworks',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerCoursesRoute = LearnerCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerCalendarRoute = LearnerCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerAwardsRoute = LearnerAwardsRouteImport.update({
  id: '/awards',
  path: '/awards',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerAnnouncementsRoute = LearnerAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerAccountRoute = LearnerAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerProfileIndexRoute = LearnerProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LearnerProfileRoute,
} as any)
const AdminGbReportCardsIdRoute = AdminGbReportCardsIdRouteImport.update({
  id: '/gb-report-cards_/$id',
  path: '/gb-report-cards/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoursesIdRoute = AdminCoursesIdRouteImport.update({
  id: '/courses_/$id',
  path: '/courses/$id',
  getParentRoute: () => AdminRoute,
} as any)
const LearnerProfileAccountRoute = LearnerProfileAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => LearnerProfileRoute,
} as any)
const LearnerHomeworksIdRoute = LearnerHomeworksIdRouteImport.update({
  id: '/homeworks_/$id',
  path: '/homeworks/$id',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerCoursesIdRoute = LearnerCoursesIdRouteImport.update({
  id: '/courses_/$id',
  path: '/courses/$id',
  getParentRoute: () => LearnerRoute,
} as any)
const LearnerAnnouncementsIdRoute = LearnerAnnouncementsIdRouteImport.update({
  id: '/announcements_/$id',
  path: '/announcements/$id',
  getParentRoute: () => LearnerRoute,
} as any)
const AdminCoursesIdIndexRoute = AdminCoursesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const LearnerHomeworksIdIndexRoute = LearnerHomeworksIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LearnerHomeworksIdRoute,
} as any)
const LearnerCoursesIdIndexRoute = LearnerCoursesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const AdminGbReportCardsIdPrintRoute =
  AdminGbReportCardsIdPrintRouteImport.update({
    id: '/gb-report-cards_/$id_/print',
    path: '/gb-report-cards/$id/print',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCoursesIdTeachersRoute = AdminCoursesIdTeachersRouteImport.update({
  id: '/teachers',
  path: '/teachers',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdSettingsRoute = AdminCoursesIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdRubricsRoute = AdminCoursesIdRubricsRouteImport.update({
  id: '/rubrics',
  path: '/rubrics',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdQuizzesRoute = AdminCoursesIdQuizzesRouteImport.update({
  id: '/quizzes',
  path: '/quizzes',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdQuestionsRoute = AdminCoursesIdQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdInfoRoute = AdminCoursesIdInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdHomeworksRoute = AdminCoursesIdHomeworksRouteImport.update({
  id: '/homeworks',
  path: '/homeworks',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdGradebookRoute = AdminCoursesIdGradebookRouteImport.update({
  id: '/gradebook',
  path: '/gradebook',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdEnrollmentsRoute =
  AdminCoursesIdEnrollmentsRouteImport.update({
    id: '/enrollments',
    path: '/enrollments',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const AdminCoursesIdCurriculumRoute =
  AdminCoursesIdCurriculumRouteImport.update({
    id: '/curriculum',
    path: '/curriculum',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const AdminCoursesIdAwardsRoute = AdminCoursesIdAwardsRouteImport.update({
  id: '/awards',
  path: '/awards',
  getParentRoute: () => AdminCoursesIdRoute,
} as any)
const AdminCoursesIdAttendanceRoute =
  AdminCoursesIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const AdminCoursesIdAssessmentsRoute =
  AdminCoursesIdAssessmentsRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const LearnerCoursesIdSurveysRoute = LearnerCoursesIdSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const LearnerCoursesIdSelfAssessmentsRoute =
  LearnerCoursesIdSelfAssessmentsRouteImport.update({
    id: '/self-assessments',
    path: '/self-assessments',
    getParentRoute: () => LearnerCoursesIdRoute,
  } as any)
const LearnerCoursesIdQuizzesRoute = LearnerCoursesIdQuizzesRouteImport.update({
  id: '/quizzes',
  path: '/quizzes',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const LearnerCoursesIdMyProgressRoute =
  LearnerCoursesIdMyProgressRouteImport.update({
    id: '/my-progress',
    path: '/my-progress',
    getParentRoute: () => LearnerCoursesIdRoute,
  } as any)
const LearnerCoursesIdGradesRoute = LearnerCoursesIdGradesRouteImport.update({
  id: '/grades',
  path: '/grades',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const LearnerCoursesIdFeedRoute = LearnerCoursesIdFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const LearnerCoursesIdContentRoute = LearnerCoursesIdContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const LearnerCoursesIdClassProgressRoute =
  LearnerCoursesIdClassProgressRouteImport.update({
    id: '/class-progress',
    path: '/class-progress',
    getParentRoute: () => LearnerCoursesIdRoute,
  } as any)
const LearnerCoursesIdCalendarRoute =
  LearnerCoursesIdCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => LearnerCoursesIdRoute,
  } as any)
const LearnerCoursesIdAttendanceRoute =
  LearnerCoursesIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => LearnerCoursesIdRoute,
  } as any)
const LearnerCoursesIdAssignmentsRoute =
  LearnerCoursesIdAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => LearnerCoursesIdRoute,
  } as any)
const LearnerCoursesIdAboutRoute = LearnerCoursesIdAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LearnerCoursesIdRoute,
} as any)
const LearnerAwardsIdCertificateRoute =
  LearnerAwardsIdCertificateRouteImport.update({
    id: '/awards_/$id/certificate',
    path: '/awards/$id/certificate',
    getParentRoute: () => LearnerRoute,
  } as any)
const LearnerCoursesIdQuizzesIndexRoute =
  LearnerCoursesIdQuizzesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearnerCoursesIdQuizzesRoute,
  } as any)
const LearnerCoursesIdClassProgressIndexRoute =
  LearnerCoursesIdClassProgressIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearnerCoursesIdClassProgressRoute,
  } as any)
const LearnerHomeworksIdSubmissionsSidRoute =
  LearnerHomeworksIdSubmissionsSidRouteImport.update({
    id: '/submissions/$sid',
    path: '/submissions/$sid',
    getParentRoute: () => LearnerHomeworksIdRoute,
  } as any)
const LearnerCoursesIdQuizzesQuizIdRoute =
  LearnerCoursesIdQuizzesQuizIdRouteImport.update({
    id: '/$quizId',
    path: '/$quizId',
    getParentRoute: () => LearnerCoursesIdQuizzesRoute,
  } as any)
const LearnerCoursesIdQuizzesQuizIdIndexRoute =
  LearnerCoursesIdQuizzesQuizIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LearnerCoursesIdQuizzesQuizIdRoute,
  } as any)
const AdminCoursesIdQuizzesQuizIdStatisticsRoute =
  AdminCoursesIdQuizzesQuizIdStatisticsRouteImport.update({
    id: '/quizzes_/$quizId/statistics',
    path: '/quizzes/$quizId/statistics',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const AdminCoursesIdQuizzesQuizIdEditRoute =
  AdminCoursesIdQuizzesQuizIdEditRouteImport.update({
    id: '/quizzes_/$quizId/edit',
    path: '/quizzes/$quizId/edit',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const AdminCoursesIdAssessmentsQuizIdEditRoute =
  AdminCoursesIdAssessmentsQuizIdEditRouteImport.update({
    id: '/assessments_/$quizId/edit',
    path: '/assessments/$quizId/edit',
    getParentRoute: () => AdminCoursesIdRoute,
  } as any)
const LearnerCoursesIdClassProgressStudentsStudentIdRoute =
  LearnerCoursesIdClassProgressStudentsStudentIdRouteImport.update({
    id: '/students/$studentId',
    path: '/students/$studentId',
    getParentRoute: () => LearnerCoursesIdClassProgressRoute,
  } as any)
const LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute =
  LearnerCoursesIdQuizzesQuizIdAttemptsIndexRouteImport.update({
    id: '/attempts/',
    path: '/attempts/',
    getParentRoute: () => LearnerCoursesIdQuizzesQuizIdRoute,
  } as any)
const LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute =
  LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRouteImport.update({
    id: '/grade/$attemptId',
    path: '/grade/$attemptId',
    getParentRoute: () => LearnerCoursesIdQuizzesQuizIdRoute,
  } as any)
const LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute =
  LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRouteImport.update({
    id: '/attempts/$attemptId',
    path: '/attempts/$attemptId',
    getParentRoute: () => LearnerCoursesIdQuizzesQuizIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/account': typeof LearnerAccountRoute
  '/announcements': typeof LearnerAnnouncementsRoute
  '/awards': typeof LearnerAwardsRoute
  '/calendar': typeof LearnerCalendarRoute
  '/courses': typeof LearnerCoursesRoute
  '/homeworks': typeof LearnerHomeworksRoute
  '/mentions': typeof LearnerMentionsRoute
  '/profile': typeof LearnerProfileRouteWithChildren
  '/progress': typeof LearnerProgressRoute
  '/admin/account': typeof AdminAccountRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/awards': typeof AdminAwardsRoute
  '/admin/calendar': typeof AdminCalendarRoute
  '/admin/courses': typeof AdminCoursesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/gb-report-cards': typeof AdminGbReportCardsRoute
  '/admin/mark-schemes': typeof AdminMarkSchemesRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/subjects': typeof AdminSubjectsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/admin/': typeof AdminIndexRoute
  '/announcements/$id': typeof LearnerAnnouncementsIdRoute
  '/courses/$id': typeof LearnerCoursesIdRouteWithChildren
  '/homeworks/$id': typeof LearnerHomeworksIdRouteWithChildren
  '/profile/account': typeof LearnerProfileAccountRoute
  '/admin/courses/$id': typeof AdminCoursesIdRouteWithChildren
  '/admin/gb-report-cards/$id': typeof AdminGbReportCardsIdRoute
  '/profile/': typeof LearnerProfileIndexRoute
  '/awards/$id/certificate': typeof LearnerAwardsIdCertificateRoute
  '/courses/$id/about': typeof LearnerCoursesIdAboutRoute
  '/courses/$id/assignments': typeof LearnerCoursesIdAssignmentsRoute
  '/courses/$id/attendance': typeof LearnerCoursesIdAttendanceRoute
  '/courses/$id/calendar': typeof LearnerCoursesIdCalendarRoute
  '/courses/$id/class-progress': typeof LearnerCoursesIdClassProgressRouteWithChildren
  '/courses/$id/content': typeof LearnerCoursesIdContentRoute
  '/courses/$id/feed': typeof LearnerCoursesIdFeedRoute
  '/courses/$id/grades': typeof LearnerCoursesIdGradesRoute
  '/courses/$id/my-progress': typeof LearnerCoursesIdMyProgressRoute
  '/courses/$id/quizzes': typeof LearnerCoursesIdQuizzesRouteWithChildren
  '/courses/$id/self-assessments': typeof LearnerCoursesIdSelfAssessmentsRoute
  '/courses/$id/surveys': typeof LearnerCoursesIdSurveysRoute
  '/admin/courses/$id/assessments': typeof AdminCoursesIdAssessmentsRoute
  '/admin/courses/$id/attendance': typeof AdminCoursesIdAttendanceRoute
  '/admin/courses/$id/awards': typeof AdminCoursesIdAwardsRoute
  '/admin/courses/$id/curriculum': typeof AdminCoursesIdCurriculumRoute
  '/admin/courses/$id/enrollments': typeof AdminCoursesIdEnrollmentsRoute
  '/admin/courses/$id/gradebook': typeof AdminCoursesIdGradebookRoute
  '/admin/courses/$id/homeworks': typeof AdminCoursesIdHomeworksRoute
  '/admin/courses/$id/info': typeof AdminCoursesIdInfoRoute
  '/admin/courses/$id/questions': typeof AdminCoursesIdQuestionsRoute
  '/admin/courses/$id/quizzes': typeof AdminCoursesIdQuizzesRoute
  '/admin/courses/$id/rubrics': typeof AdminCoursesIdRubricsRoute
  '/admin/courses/$id/settings': typeof AdminCoursesIdSettingsRoute
  '/admin/courses/$id/teachers': typeof AdminCoursesIdTeachersRoute
  '/admin/gb-report-cards/$id/print': typeof AdminGbReportCardsIdPrintRoute
  '/courses/$id/': typeof LearnerCoursesIdIndexRoute
  '/homeworks/$id/': typeof LearnerHomeworksIdIndexRoute
  '/admin/courses/$id/': typeof AdminCoursesIdIndexRoute
  '/courses/$id/quizzes/$quizId': typeof LearnerCoursesIdQuizzesQuizIdRouteWithChildren
  '/homeworks/$id/submissions/$sid': typeof LearnerHomeworksIdSubmissionsSidRoute
  '/courses/$id/class-progress/': typeof LearnerCoursesIdClassProgressIndexRoute
  '/courses/$id/quizzes/': typeof LearnerCoursesIdQuizzesIndexRoute
  '/courses/$id/class-progress/students/$studentId': typeof LearnerCoursesIdClassProgressStudentsStudentIdRoute
  '/admin/courses/$id/assessments/$quizId/edit': typeof AdminCoursesIdAssessmentsQuizIdEditRoute
  '/admin/courses/$id/quizzes/$quizId/edit': typeof AdminCoursesIdQuizzesQuizIdEditRoute
  '/admin/courses/$id/quizzes/$quizId/statistics': typeof AdminCoursesIdQuizzesQuizIdStatisticsRoute
  '/courses/$id/quizzes/$quizId/': typeof LearnerCoursesIdQuizzesQuizIdIndexRoute
  '/courses/$id/quizzes/$quizId/attempts/$attemptId': typeof LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute
  '/courses/$id/quizzes/$quizId/grade/$attemptId': typeof LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute
  '/courses/$id/quizzes/$quizId/attempts/': typeof LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/account': typeof LearnerAccountRoute
  '/announcements': typeof LearnerAnnouncementsRoute
  '/awards': typeof LearnerAwardsRoute
  '/calendar': typeof LearnerCalendarRoute
  '/courses': typeof LearnerCoursesRoute
  '/homeworks': typeof LearnerHomeworksRoute
  '/mentions': typeof LearnerMentionsRoute
  '/progress': typeof LearnerProgressRoute
  '/admin/account': typeof AdminAccountRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/awards': typeof AdminAwardsRoute
  '/admin/calendar': typeof AdminCalendarRoute
  '/admin/courses': typeof AdminCoursesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/gb-report-cards': typeof AdminGbReportCardsRoute
  '/admin/mark-schemes': typeof AdminMarkSchemesRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/subjects': typeof AdminSubjectsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/admin': typeof AdminIndexRoute
  '/announcements/$id': typeof LearnerAnnouncementsIdRoute
  '/profile/account': typeof LearnerProfileAccountRoute
  '/admin/gb-report-cards/$id': typeof AdminGbReportCardsIdRoute
  '/profile': typeof LearnerProfileIndexRoute
  '/awards/$id/certificate': typeof LearnerAwardsIdCertificateRoute
  '/courses/$id/about': typeof LearnerCoursesIdAboutRoute
  '/courses/$id/assignments': typeof LearnerCoursesIdAssignmentsRoute
  '/courses/$id/attendance': typeof LearnerCoursesIdAttendanceRoute
  '/courses/$id/calendar': typeof LearnerCoursesIdCalendarRoute
  '/courses/$id/content': typeof LearnerCoursesIdContentRoute
  '/courses/$id/feed': typeof LearnerCoursesIdFeedRoute
  '/courses/$id/grades': typeof LearnerCoursesIdGradesRoute
  '/courses/$id/my-progress': typeof LearnerCoursesIdMyProgressRoute
  '/courses/$id/self-assessments': typeof LearnerCoursesIdSelfAssessmentsRoute
  '/courses/$id/surveys': typeof LearnerCoursesIdSurveysRoute
  '/admin/courses/$id/assessments': typeof AdminCoursesIdAssessmentsRoute
  '/admin/courses/$id/attendance': typeof AdminCoursesIdAttendanceRoute
  '/admin/courses/$id/awards': typeof AdminCoursesIdAwardsRoute
  '/admin/courses/$id/curriculum': typeof AdminCoursesIdCurriculumRoute
  '/admin/courses/$id/enrollments': typeof AdminCoursesIdEnrollmentsRoute
  '/admin/courses/$id/gradebook': typeof AdminCoursesIdGradebookRoute
  '/admin/courses/$id/homeworks': typeof AdminCoursesIdHomeworksRoute
  '/admin/courses/$id/info': typeof AdminCoursesIdInfoRoute
  '/admin/courses/$id/questions': typeof AdminCoursesIdQuestionsRoute
  '/admin/courses/$id/quizzes': typeof AdminCoursesIdQuizzesRoute
  '/admin/courses/$id/rubrics': typeof AdminCoursesIdRubricsRoute
  '/admin/courses/$id/settings': typeof AdminCoursesIdSettingsRoute
  '/admin/courses/$id/teachers': typeof AdminCoursesIdTeachersRoute
  '/admin/gb-report-cards/$id/print': typeof AdminGbReportCardsIdPrintRoute
  '/courses/$id': typeof LearnerCoursesIdIndexRoute
  '/homeworks/$id': typeof LearnerHomeworksIdIndexRoute
  '/admin/courses/$id': typeof AdminCoursesIdIndexRoute
  '/homeworks/$id/submissions/$sid': typeof LearnerHomeworksIdSubmissionsSidRoute
  '/courses/$id/class-progress': typeof LearnerCoursesIdClassProgressIndexRoute
  '/courses/$id/quizzes': typeof LearnerCoursesIdQuizzesIndexRoute
  '/courses/$id/class-progress/students/$studentId': typeof LearnerCoursesIdClassProgressStudentsStudentIdRoute
  '/admin/courses/$id/assessments/$quizId/edit': typeof AdminCoursesIdAssessmentsQuizIdEditRoute
  '/admin/courses/$id/quizzes/$quizId/edit': typeof AdminCoursesIdQuizzesQuizIdEditRoute
  '/admin/courses/$id/quizzes/$quizId/statistics': typeof AdminCoursesIdQuizzesQuizIdStatisticsRoute
  '/courses/$id/quizzes/$quizId': typeof LearnerCoursesIdQuizzesQuizIdIndexRoute
  '/courses/$id/quizzes/$quizId/attempts/$attemptId': typeof LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute
  '/courses/$id/quizzes/$quizId/grade/$attemptId': typeof LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute
  '/courses/$id/quizzes/$quizId/attempts': typeof LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_learner': typeof LearnerRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/_learner/account': typeof LearnerAccountRoute
  '/_learner/announcements': typeof LearnerAnnouncementsRoute
  '/_learner/awards': typeof LearnerAwardsRoute
  '/_learner/calendar': typeof LearnerCalendarRoute
  '/_learner/courses': typeof LearnerCoursesRoute
  '/_learner/homeworks': typeof LearnerHomeworksRoute
  '/_learner/mentions': typeof LearnerMentionsRoute
  '/_learner/profile': typeof LearnerProfileRouteWithChildren
  '/_learner/progress': typeof LearnerProgressRoute
  '/admin/account': typeof AdminAccountRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/awards': typeof AdminAwardsRoute
  '/admin/calendar': typeof AdminCalendarRoute
  '/admin/courses': typeof AdminCoursesRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/gb-report-cards': typeof AdminGbReportCardsRoute
  '/admin/mark-schemes': typeof AdminMarkSchemesRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/subjects': typeof AdminSubjectsRoute
  '/admin/teachers': typeof AdminTeachersRoute
  '/admin/': typeof AdminIndexRoute
  '/_learner/announcements_/$id': typeof LearnerAnnouncementsIdRoute
  '/_learner/courses_/$id': typeof LearnerCoursesIdRouteWithChildren
  '/_learner/homeworks_/$id': typeof LearnerHomeworksIdRouteWithChildren
  '/_learner/profile/account': typeof LearnerProfileAccountRoute
  '/admin/courses_/$id': typeof AdminCoursesIdRouteWithChildren
  '/admin/gb-report-cards_/$id': typeof AdminGbReportCardsIdRoute
  '/_learner/profile/': typeof LearnerProfileIndexRoute
  '/_learner/awards_/$id/certificate': typeof LearnerAwardsIdCertificateRoute
  '/_learner/courses_/$id/about': typeof LearnerCoursesIdAboutRoute
  '/_learner/courses_/$id/assignments': typeof LearnerCoursesIdAssignmentsRoute
  '/_learner/courses_/$id/attendance': typeof LearnerCoursesIdAttendanceRoute
  '/_learner/courses_/$id/calendar': typeof LearnerCoursesIdCalendarRoute
  '/_learner/courses_/$id/class-progress': typeof LearnerCoursesIdClassProgressRouteWithChildren
  '/_learner/courses_/$id/content': typeof LearnerCoursesIdContentRoute
  '/_learner/courses_/$id/feed': typeof LearnerCoursesIdFeedRoute
  '/_learner/courses_/$id/grades': typeof LearnerCoursesIdGradesRoute
  '/_learner/courses_/$id/my-progress': typeof LearnerCoursesIdMyProgressRoute
  '/_learner/courses_/$id/quizzes': typeof LearnerCoursesIdQuizzesRouteWithChildren
  '/_learner/courses_/$id/self-assessments': typeof LearnerCoursesIdSelfAssessmentsRoute
  '/_learner/courses_/$id/surveys': typeof LearnerCoursesIdSurveysRoute
  '/admin/courses_/$id/assessments': typeof AdminCoursesIdAssessmentsRoute
  '/admin/courses_/$id/attendance': typeof AdminCoursesIdAttendanceRoute
  '/admin/courses_/$id/awards': typeof AdminCoursesIdAwardsRoute
  '/admin/courses_/$id/curriculum': typeof AdminCoursesIdCurriculumRoute
  '/admin/courses_/$id/enrollments': typeof AdminCoursesIdEnrollmentsRoute
  '/admin/courses_/$id/gradebook': typeof AdminCoursesIdGradebookRoute
  '/admin/courses_/$id/homeworks': typeof AdminCoursesIdHomeworksRoute
  '/admin/courses_/$id/info': typeof AdminCoursesIdInfoRoute
  '/admin/courses_/$id/questions': typeof AdminCoursesIdQuestionsRoute
  '/admin/courses_/$id/quizzes': typeof AdminCoursesIdQuizzesRoute
  '/admin/courses_/$id/rubrics': typeof AdminCoursesIdRubricsRoute
  '/admin/courses_/$id/settings': typeof AdminCoursesIdSettingsRoute
  '/admin/courses_/$id/teachers': typeof AdminCoursesIdTeachersRoute
  '/admin/gb-report-cards_/$id_/print': typeof AdminGbReportCardsIdPrintRoute
  '/_learner/courses_/$id/': typeof LearnerCoursesIdIndexRoute
  '/_learner/homeworks_/$id/': typeof LearnerHomeworksIdIndexRoute
  '/admin/courses_/$id/': typeof AdminCoursesIdIndexRoute
  '/_learner/courses_/$id/quizzes/$quizId': typeof LearnerCoursesIdQuizzesQuizIdRouteWithChildren
  '/_learner/homeworks_/$id/submissions/$sid': typeof LearnerHomeworksIdSubmissionsSidRoute
  '/_learner/courses_/$id/class-progress/': typeof LearnerCoursesIdClassProgressIndexRoute
  '/_learner/courses_/$id/quizzes/': typeof LearnerCoursesIdQuizzesIndexRoute
  '/_learner/courses_/$id/class-progress/students/$studentId': typeof LearnerCoursesIdClassProgressStudentsStudentIdRoute
  '/admin/courses_/$id/assessments_/$quizId/edit': typeof AdminCoursesIdAssessmentsQuizIdEditRoute
  '/admin/courses_/$id/quizzes_/$quizId/edit': typeof AdminCoursesIdQuizzesQuizIdEditRoute
  '/admin/courses_/$id/quizzes_/$quizId/statistics': typeof AdminCoursesIdQuizzesQuizIdStatisticsRoute
  '/_learner/courses_/$id/quizzes/$quizId/': typeof LearnerCoursesIdQuizzesQuizIdIndexRoute
  '/_learner/courses_/$id/quizzes/$quizId/attempts/$attemptId': typeof LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute
  '/_learner/courses_/$id/quizzes/$quizId/grade/$attemptId': typeof LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute
  '/_learner/courses_/$id/quizzes/$quizId/attempts/': typeof LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/account'
    | '/announcements'
    | '/awards'
    | '/calendar'
    | '/courses'
    | '/homeworks'
    | '/mentions'
    | '/profile'
    | '/progress'
    | '/admin/account'
    | '/admin/announcements'
    | '/admin/awards'
    | '/admin/calendar'
    | '/admin/courses'
    | '/admin/dashboard'
    | '/admin/gb-report-cards'
    | '/admin/mark-schemes'
    | '/admin/students'
    | '/admin/subjects'
    | '/admin/teachers'
    | '/admin/'
    | '/announcements/$id'
    | '/courses/$id'
    | '/homeworks/$id'
    | '/profile/account'
    | '/admin/courses/$id'
    | '/admin/gb-report-cards/$id'
    | '/profile/'
    | '/awards/$id/certificate'
    | '/courses/$id/about'
    | '/courses/$id/assignments'
    | '/courses/$id/attendance'
    | '/courses/$id/calendar'
    | '/courses/$id/class-progress'
    | '/courses/$id/content'
    | '/courses/$id/feed'
    | '/courses/$id/grades'
    | '/courses/$id/my-progress'
    | '/courses/$id/quizzes'
    | '/courses/$id/self-assessments'
    | '/courses/$id/surveys'
    | '/admin/courses/$id/assessments'
    | '/admin/courses/$id/attendance'
    | '/admin/courses/$id/awards'
    | '/admin/courses/$id/curriculum'
    | '/admin/courses/$id/enrollments'
    | '/admin/courses/$id/gradebook'
    | '/admin/courses/$id/homeworks'
    | '/admin/courses/$id/info'
    | '/admin/courses/$id/questions'
    | '/admin/courses/$id/quizzes'
    | '/admin/courses/$id/rubrics'
    | '/admin/courses/$id/settings'
    | '/admin/courses/$id/teachers'
    | '/admin/gb-report-cards/$id/print'
    | '/courses/$id/'
    | '/homeworks/$id/'
    | '/admin/courses/$id/'
    | '/courses/$id/quizzes/$quizId'
    | '/homeworks/$id/submissions/$sid'
    | '/courses/$id/class-progress/'
    | '/courses/$id/quizzes/'
    | '/courses/$id/class-progress/students/$studentId'
    | '/admin/courses/$id/assessments/$quizId/edit'
    | '/admin/courses/$id/quizzes/$quizId/edit'
    | '/admin/courses/$id/quizzes/$quizId/statistics'
    | '/courses/$id/quizzes/$quizId/'
    | '/courses/$id/quizzes/$quizId/attempts/$attemptId'
    | '/courses/$id/quizzes/$quizId/grade/$attemptId'
    | '/courses/$id/quizzes/$quizId/attempts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/account'
    | '/announcements'
    | '/awards'
    | '/calendar'
    | '/courses'
    | '/homeworks'
    | '/mentions'
    | '/progress'
    | '/admin/account'
    | '/admin/announcements'
    | '/admin/awards'
    | '/admin/calendar'
    | '/admin/courses'
    | '/admin/dashboard'
    | '/admin/gb-report-cards'
    | '/admin/mark-schemes'
    | '/admin/students'
    | '/admin/subjects'
    | '/admin/teachers'
    | '/admin'
    | '/announcements/$id'
    | '/profile/account'
    | '/admin/gb-report-cards/$id'
    | '/profile'
    | '/awards/$id/certificate'
    | '/courses/$id/about'
    | '/courses/$id/assignments'
    | '/courses/$id/attendance'
    | '/courses/$id/calendar'
    | '/courses/$id/content'
    | '/courses/$id/feed'
    | '/courses/$id/grades'
    | '/courses/$id/my-progress'
    | '/courses/$id/self-assessments'
    | '/courses/$id/surveys'
    | '/admin/courses/$id/assessments'
    | '/admin/courses/$id/attendance'
    | '/admin/courses/$id/awards'
    | '/admin/courses/$id/curriculum'
    | '/admin/courses/$id/enrollments'
    | '/admin/courses/$id/gradebook'
    | '/admin/courses/$id/homeworks'
    | '/admin/courses/$id/info'
    | '/admin/courses/$id/questions'
    | '/admin/courses/$id/quizzes'
    | '/admin/courses/$id/rubrics'
    | '/admin/courses/$id/settings'
    | '/admin/courses/$id/teachers'
    | '/admin/gb-report-cards/$id/print'
    | '/courses/$id'
    | '/homeworks/$id'
    | '/admin/courses/$id'
    | '/homeworks/$id/submissions/$sid'
    | '/courses/$id/class-progress'
    | '/courses/$id/quizzes'
    | '/courses/$id/class-progress/students/$studentId'
    | '/admin/courses/$id/assessments/$quizId/edit'
    | '/admin/courses/$id/quizzes/$quizId/edit'
    | '/admin/courses/$id/quizzes/$quizId/statistics'
    | '/courses/$id/quizzes/$quizId'
    | '/courses/$id/quizzes/$quizId/attempts/$attemptId'
    | '/courses/$id/quizzes/$quizId/grade/$attemptId'
    | '/courses/$id/quizzes/$quizId/attempts'
  id:
    | '__root__'
    | '/'
    | '/_learner'
    | '/admin'
    | '/login'
    | '/_learner/account'
    | '/_learner/announcements'
    | '/_learner/awards'
    | '/_learner/calendar'
    | '/_learner/courses'
    | '/_learner/homeworks'
    | '/_learner/mentions'
    | '/_learner/profile'
    | '/_learner/progress'
    | '/admin/account'
    | '/admin/announcements'
    | '/admin/awards'
    | '/admin/calendar'
    | '/admin/courses'
    | '/admin/dashboard'
    | '/admin/gb-report-cards'
    | '/admin/mark-schemes'
    | '/admin/students'
    | '/admin/subjects'
    | '/admin/teachers'
    | '/admin/'
    | '/_learner/announcements_/$id'
    | '/_learner/courses_/$id'
    | '/_learner/homeworks_/$id'
    | '/_learner/profile/account'
    | '/admin/courses_/$id'
    | '/admin/gb-report-cards_/$id'
    | '/_learner/profile/'
    | '/_learner/awards_/$id/certificate'
    | '/_learner/courses_/$id/about'
    | '/_learner/courses_/$id/assignments'
    | '/_learner/courses_/$id/attendance'
    | '/_learner/courses_/$id/calendar'
    | '/_learner/courses_/$id/class-progress'
    | '/_learner/courses_/$id/content'
    | '/_learner/courses_/$id/feed'
    | '/_learner/courses_/$id/grades'
    | '/_learner/courses_/$id/my-progress'
    | '/_learner/courses_/$id/quizzes'
    | '/_learner/courses_/$id/self-assessments'
    | '/_learner/courses_/$id/surveys'
    | '/admin/courses_/$id/assessments'
    | '/admin/courses_/$id/attendance'
    | '/admin/courses_/$id/awards'
    | '/admin/courses_/$id/curriculum'
    | '/admin/courses_/$id/enrollments'
    | '/admin/courses_/$id/gradebook'
    | '/admin/courses_/$id/homeworks'
    | '/admin/courses_/$id/info'
    | '/admin/courses_/$id/questions'
    | '/admin/courses_/$id/quizzes'
    | '/admin/courses_/$id/rubrics'
    | '/admin/courses_/$id/settings'
    | '/admin/courses_/$id/teachers'
    | '/admin/gb-report-cards_/$id_/print'
    | '/_learner/courses_/$id/'
    | '/_learner/homeworks_/$id/'
    | '/admin/courses_/$id/'
    | '/_learner/courses_/$id/quizzes/$quizId'
    | '/_learner/homeworks_/$id/submissions/$sid'
    | '/_learner/courses_/$id/class-progress/'
    | '/_learner/courses_/$id/quizzes/'
    | '/_learner/courses_/$id/class-progress/students/$studentId'
    | '/admin/courses_/$id/assessments_/$quizId/edit'
    | '/admin/courses_/$id/quizzes_/$quizId/edit'
    | '/admin/courses_/$id/quizzes_/$quizId/statistics'
    | '/_learner/courses_/$id/quizzes/$quizId/'
    | '/_learner/courses_/$id/quizzes/$quizId/attempts/$attemptId'
    | '/_learner/courses_/$id/quizzes/$quizId/grade/$attemptId'
    | '/_learner/courses_/$id/quizzes/$quizId/attempts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LearnerRoute: typeof LearnerRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_learner': {
      id: '/_learner'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LearnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/teachers': {
      id: '/admin/teachers'
      path: '/teachers'
      fullPath: '/admin/teachers'
      preLoaderRoute: typeof AdminTeachersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/subjects': {
      id: '/admin/subjects'
      path: '/subjects'
      fullPath: '/admin/subjects'
      preLoaderRoute: typeof AdminSubjectsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/students': {
      id: '/admin/students'
      path: '/students'
      fullPath: '/admin/students'
      preLoaderRoute: typeof AdminStudentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mark-schemes': {
      id: '/admin/mark-schemes'
      path: '/mark-schemes'
      fullPath: '/admin/mark-schemes'
      preLoaderRoute: typeof AdminMarkSchemesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/gb-report-cards': {
      id: '/admin/gb-report-cards'
      path: '/gb-report-cards'
      fullPath: '/admin/gb-report-cards'
      preLoaderRoute: typeof AdminGbReportCardsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/courses': {
      id: '/admin/courses'
      path: '/courses'
      fullPath: '/admin/courses'
      preLoaderRoute: typeof AdminCoursesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/calendar': {
      id: '/admin/calendar'
      path: '/calendar'
      fullPath: '/admin/calendar'
      preLoaderRoute: typeof AdminCalendarRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/awards': {
      id: '/admin/awards'
      path: '/awards'
      fullPath: '/admin/awards'
      preLoaderRoute: typeof AdminAwardsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/account': {
      id: '/admin/account'
      path: '/account'
      fullPath: '/admin/account'
      preLoaderRoute: typeof AdminAccountRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_learner/progress': {
      id: '/_learner/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof LearnerProgressRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/profile': {
      id: '/_learner/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LearnerProfileRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/mentions': {
      id: '/_learner/mentions'
      path: '/mentions'
      fullPath: '/mentions'
      preLoaderRoute: typeof LearnerMentionsRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/homeworks': {
      id: '/_learner/homeworks'
      path: '/homeworks'
      fullPath: '/homeworks'
      preLoaderRoute: typeof LearnerHomeworksRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/courses': {
      id: '/_learner/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof LearnerCoursesRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/calendar': {
      id: '/_learner/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof LearnerCalendarRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/awards': {
      id: '/_learner/awards'
      path: '/awards'
      fullPath: '/awards'
      preLoaderRoute: typeof LearnerAwardsRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/announcements': {
      id: '/_learner/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof LearnerAnnouncementsRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/account': {
      id: '/_learner/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof LearnerAccountRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/profile/': {
      id: '/_learner/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof LearnerProfileIndexRouteImport
      parentRoute: typeof LearnerProfileRoute
    }
    '/admin/gb-report-cards_/$id': {
      id: '/admin/gb-report-cards_/$id'
      path: '/gb-report-cards/$id'
      fullPath: '/admin/gb-report-cards/$id'
      preLoaderRoute: typeof AdminGbReportCardsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/courses_/$id': {
      id: '/admin/courses_/$id'
      path: '/courses/$id'
      fullPath: '/admin/courses/$id'
      preLoaderRoute: typeof AdminCoursesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_learner/profile/account': {
      id: '/_learner/profile/account'
      path: '/account'
      fullPath: '/profile/account'
      preLoaderRoute: typeof LearnerProfileAccountRouteImport
      parentRoute: typeof LearnerProfileRoute
    }
    '/_learner/homeworks_/$id': {
      id: '/_learner/homeworks_/$id'
      path: '/homeworks/$id'
      fullPath: '/homeworks/$id'
      preLoaderRoute: typeof LearnerHomeworksIdRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/courses_/$id': {
      id: '/_learner/courses_/$id'
      path: '/courses/$id'
      fullPath: '/courses/$id'
      preLoaderRoute: typeof LearnerCoursesIdRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/announcements_/$id': {
      id: '/_learner/announcements_/$id'
      path: '/announcements/$id'
      fullPath: '/announcements/$id'
      preLoaderRoute: typeof LearnerAnnouncementsIdRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/admin/courses_/$id/': {
      id: '/admin/courses_/$id/'
      path: '/'
      fullPath: '/admin/courses/$id/'
      preLoaderRoute: typeof AdminCoursesIdIndexRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/_learner/homeworks_/$id/': {
      id: '/_learner/homeworks_/$id/'
      path: '/'
      fullPath: '/homeworks/$id/'
      preLoaderRoute: typeof LearnerHomeworksIdIndexRouteImport
      parentRoute: typeof LearnerHomeworksIdRoute
    }
    '/_learner/courses_/$id/': {
      id: '/_learner/courses_/$id/'
      path: '/'
      fullPath: '/courses/$id/'
      preLoaderRoute: typeof LearnerCoursesIdIndexRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/admin/gb-report-cards_/$id_/print': {
      id: '/admin/gb-report-cards_/$id_/print'
      path: '/gb-report-cards/$id/print'
      fullPath: '/admin/gb-report-cards/$id/print'
      preLoaderRoute: typeof AdminGbReportCardsIdPrintRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/courses_/$id/teachers': {
      id: '/admin/courses_/$id/teachers'
      path: '/teachers'
      fullPath: '/admin/courses/$id/teachers'
      preLoaderRoute: typeof AdminCoursesIdTeachersRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/settings': {
      id: '/admin/courses_/$id/settings'
      path: '/settings'
      fullPath: '/admin/courses/$id/settings'
      preLoaderRoute: typeof AdminCoursesIdSettingsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/rubrics': {
      id: '/admin/courses_/$id/rubrics'
      path: '/rubrics'
      fullPath: '/admin/courses/$id/rubrics'
      preLoaderRoute: typeof AdminCoursesIdRubricsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/quizzes': {
      id: '/admin/courses_/$id/quizzes'
      path: '/quizzes'
      fullPath: '/admin/courses/$id/quizzes'
      preLoaderRoute: typeof AdminCoursesIdQuizzesRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/questions': {
      id: '/admin/courses_/$id/questions'
      path: '/questions'
      fullPath: '/admin/courses/$id/questions'
      preLoaderRoute: typeof AdminCoursesIdQuestionsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/info': {
      id: '/admin/courses_/$id/info'
      path: '/info'
      fullPath: '/admin/courses/$id/info'
      preLoaderRoute: typeof AdminCoursesIdInfoRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/homeworks': {
      id: '/admin/courses_/$id/homeworks'
      path: '/homeworks'
      fullPath: '/admin/courses/$id/homeworks'
      preLoaderRoute: typeof AdminCoursesIdHomeworksRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/gradebook': {
      id: '/admin/courses_/$id/gradebook'
      path: '/gradebook'
      fullPath: '/admin/courses/$id/gradebook'
      preLoaderRoute: typeof AdminCoursesIdGradebookRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/enrollments': {
      id: '/admin/courses_/$id/enrollments'
      path: '/enrollments'
      fullPath: '/admin/courses/$id/enrollments'
      preLoaderRoute: typeof AdminCoursesIdEnrollmentsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/curriculum': {
      id: '/admin/courses_/$id/curriculum'
      path: '/curriculum'
      fullPath: '/admin/courses/$id/curriculum'
      preLoaderRoute: typeof AdminCoursesIdCurriculumRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/awards': {
      id: '/admin/courses_/$id/awards'
      path: '/awards'
      fullPath: '/admin/courses/$id/awards'
      preLoaderRoute: typeof AdminCoursesIdAwardsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/attendance': {
      id: '/admin/courses_/$id/attendance'
      path: '/attendance'
      fullPath: '/admin/courses/$id/attendance'
      preLoaderRoute: typeof AdminCoursesIdAttendanceRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/assessments': {
      id: '/admin/courses_/$id/assessments'
      path: '/assessments'
      fullPath: '/admin/courses/$id/assessments'
      preLoaderRoute: typeof AdminCoursesIdAssessmentsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/_learner/courses_/$id/surveys': {
      id: '/_learner/courses_/$id/surveys'
      path: '/surveys'
      fullPath: '/courses/$id/surveys'
      preLoaderRoute: typeof LearnerCoursesIdSurveysRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/self-assessments': {
      id: '/_learner/courses_/$id/self-assessments'
      path: '/self-assessments'
      fullPath: '/courses/$id/self-assessments'
      preLoaderRoute: typeof LearnerCoursesIdSelfAssessmentsRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/quizzes': {
      id: '/_learner/courses_/$id/quizzes'
      path: '/quizzes'
      fullPath: '/courses/$id/quizzes'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/my-progress': {
      id: '/_learner/courses_/$id/my-progress'
      path: '/my-progress'
      fullPath: '/courses/$id/my-progress'
      preLoaderRoute: typeof LearnerCoursesIdMyProgressRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/grades': {
      id: '/_learner/courses_/$id/grades'
      path: '/grades'
      fullPath: '/courses/$id/grades'
      preLoaderRoute: typeof LearnerCoursesIdGradesRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/feed': {
      id: '/_learner/courses_/$id/feed'
      path: '/feed'
      fullPath: '/courses/$id/feed'
      preLoaderRoute: typeof LearnerCoursesIdFeedRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/content': {
      id: '/_learner/courses_/$id/content'
      path: '/content'
      fullPath: '/courses/$id/content'
      preLoaderRoute: typeof LearnerCoursesIdContentRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/class-progress': {
      id: '/_learner/courses_/$id/class-progress'
      path: '/class-progress'
      fullPath: '/courses/$id/class-progress'
      preLoaderRoute: typeof LearnerCoursesIdClassProgressRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/calendar': {
      id: '/_learner/courses_/$id/calendar'
      path: '/calendar'
      fullPath: '/courses/$id/calendar'
      preLoaderRoute: typeof LearnerCoursesIdCalendarRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/attendance': {
      id: '/_learner/courses_/$id/attendance'
      path: '/attendance'
      fullPath: '/courses/$id/attendance'
      preLoaderRoute: typeof LearnerCoursesIdAttendanceRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/assignments': {
      id: '/_learner/courses_/$id/assignments'
      path: '/assignments'
      fullPath: '/courses/$id/assignments'
      preLoaderRoute: typeof LearnerCoursesIdAssignmentsRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/courses_/$id/about': {
      id: '/_learner/courses_/$id/about'
      path: '/about'
      fullPath: '/courses/$id/about'
      preLoaderRoute: typeof LearnerCoursesIdAboutRouteImport
      parentRoute: typeof LearnerCoursesIdRoute
    }
    '/_learner/awards_/$id/certificate': {
      id: '/_learner/awards_/$id/certificate'
      path: '/awards/$id/certificate'
      fullPath: '/awards/$id/certificate'
      preLoaderRoute: typeof LearnerAwardsIdCertificateRouteImport
      parentRoute: typeof LearnerRoute
    }
    '/_learner/courses_/$id/quizzes/': {
      id: '/_learner/courses_/$id/quizzes/'
      path: '/'
      fullPath: '/courses/$id/quizzes/'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesIndexRouteImport
      parentRoute: typeof LearnerCoursesIdQuizzesRoute
    }
    '/_learner/courses_/$id/class-progress/': {
      id: '/_learner/courses_/$id/class-progress/'
      path: '/'
      fullPath: '/courses/$id/class-progress/'
      preLoaderRoute: typeof LearnerCoursesIdClassProgressIndexRouteImport
      parentRoute: typeof LearnerCoursesIdClassProgressRoute
    }
    '/_learner/homeworks_/$id/submissions/$sid': {
      id: '/_learner/homeworks_/$id/submissions/$sid'
      path: '/submissions/$sid'
      fullPath: '/homeworks/$id/submissions/$sid'
      preLoaderRoute: typeof LearnerHomeworksIdSubmissionsSidRouteImport
      parentRoute: typeof LearnerHomeworksIdRoute
    }
    '/_learner/courses_/$id/quizzes/$quizId': {
      id: '/_learner/courses_/$id/quizzes/$quizId'
      path: '/$quizId'
      fullPath: '/courses/$id/quizzes/$quizId'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesQuizIdRouteImport
      parentRoute: typeof LearnerCoursesIdQuizzesRoute
    }
    '/_learner/courses_/$id/quizzes/$quizId/': {
      id: '/_learner/courses_/$id/quizzes/$quizId/'
      path: '/'
      fullPath: '/courses/$id/quizzes/$quizId/'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesQuizIdIndexRouteImport
      parentRoute: typeof LearnerCoursesIdQuizzesQuizIdRoute
    }
    '/admin/courses_/$id/quizzes_/$quizId/statistics': {
      id: '/admin/courses_/$id/quizzes_/$quizId/statistics'
      path: '/quizzes/$quizId/statistics'
      fullPath: '/admin/courses/$id/quizzes/$quizId/statistics'
      preLoaderRoute: typeof AdminCoursesIdQuizzesQuizIdStatisticsRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/quizzes_/$quizId/edit': {
      id: '/admin/courses_/$id/quizzes_/$quizId/edit'
      path: '/quizzes/$quizId/edit'
      fullPath: '/admin/courses/$id/quizzes/$quizId/edit'
      preLoaderRoute: typeof AdminCoursesIdQuizzesQuizIdEditRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/admin/courses_/$id/assessments_/$quizId/edit': {
      id: '/admin/courses_/$id/assessments_/$quizId/edit'
      path: '/assessments/$quizId/edit'
      fullPath: '/admin/courses/$id/assessments/$quizId/edit'
      preLoaderRoute: typeof AdminCoursesIdAssessmentsQuizIdEditRouteImport
      parentRoute: typeof AdminCoursesIdRoute
    }
    '/_learner/courses_/$id/class-progress/students/$studentId': {
      id: '/_learner/courses_/$id/class-progress/students/$studentId'
      path: '/students/$studentId'
      fullPath: '/courses/$id/class-progress/students/$studentId'
      preLoaderRoute: typeof LearnerCoursesIdClassProgressStudentsStudentIdRouteImport
      parentRoute: typeof LearnerCoursesIdClassProgressRoute
    }
    '/_learner/courses_/$id/quizzes/$quizId/attempts/': {
      id: '/_learner/courses_/$id/quizzes/$quizId/attempts/'
      path: '/attempts'
      fullPath: '/courses/$id/quizzes/$quizId/attempts/'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesQuizIdAttemptsIndexRouteImport
      parentRoute: typeof LearnerCoursesIdQuizzesQuizIdRoute
    }
    '/_learner/courses_/$id/quizzes/$quizId/grade/$attemptId': {
      id: '/_learner/courses_/$id/quizzes/$quizId/grade/$attemptId'
      path: '/grade/$attemptId'
      fullPath: '/courses/$id/quizzes/$quizId/grade/$attemptId'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRouteImport
      parentRoute: typeof LearnerCoursesIdQuizzesQuizIdRoute
    }
    '/_learner/courses_/$id/quizzes/$quizId/attempts/$attemptId': {
      id: '/_learner/courses_/$id/quizzes/$quizId/attempts/$attemptId'
      path: '/attempts/$attemptId'
      fullPath: '/courses/$id/quizzes/$quizId/attempts/$attemptId'
      preLoaderRoute: typeof LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRouteImport
      parentRoute: typeof LearnerCoursesIdQuizzesQuizIdRoute
    }
  }
}

interface LearnerProfileRouteChildren {
  LearnerProfileAccountRoute: typeof LearnerProfileAccountRoute
  LearnerProfileIndexRoute: typeof LearnerProfileIndexRoute
}

const LearnerProfileRouteChildren: LearnerProfileRouteChildren = {
  LearnerProfileAccountRoute: LearnerProfileAccountRoute,
  LearnerProfileIndexRoute: LearnerProfileIndexRoute,
}

const LearnerProfileRouteWithChildren = LearnerProfileRoute._addFileChildren(
  LearnerProfileRouteChildren,
)

interface LearnerCoursesIdClassProgressRouteChildren {
  LearnerCoursesIdClassProgressIndexRoute: typeof LearnerCoursesIdClassProgressIndexRoute
  LearnerCoursesIdClassProgressStudentsStudentIdRoute: typeof LearnerCoursesIdClassProgressStudentsStudentIdRoute
}

const LearnerCoursesIdClassProgressRouteChildren: LearnerCoursesIdClassProgressRouteChildren =
  {
    LearnerCoursesIdClassProgressIndexRoute:
      LearnerCoursesIdClassProgressIndexRoute,
    LearnerCoursesIdClassProgressStudentsStudentIdRoute:
      LearnerCoursesIdClassProgressStudentsStudentIdRoute,
  }

const LearnerCoursesIdClassProgressRouteWithChildren =
  LearnerCoursesIdClassProgressRoute._addFileChildren(
    LearnerCoursesIdClassProgressRouteChildren,
  )

interface LearnerCoursesIdQuizzesQuizIdRouteChildren {
  LearnerCoursesIdQuizzesQuizIdIndexRoute: typeof LearnerCoursesIdQuizzesQuizIdIndexRoute
  LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute: typeof LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute
  LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute: typeof LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute
  LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute: typeof LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute
}

const LearnerCoursesIdQuizzesQuizIdRouteChildren: LearnerCoursesIdQuizzesQuizIdRouteChildren =
  {
    LearnerCoursesIdQuizzesQuizIdIndexRoute:
      LearnerCoursesIdQuizzesQuizIdIndexRoute,
    LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute:
      LearnerCoursesIdQuizzesQuizIdAttemptsAttemptIdRoute,
    LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute:
      LearnerCoursesIdQuizzesQuizIdGradeAttemptIdRoute,
    LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute:
      LearnerCoursesIdQuizzesQuizIdAttemptsIndexRoute,
  }

const LearnerCoursesIdQuizzesQuizIdRouteWithChildren =
  LearnerCoursesIdQuizzesQuizIdRoute._addFileChildren(
    LearnerCoursesIdQuizzesQuizIdRouteChildren,
  )

interface LearnerCoursesIdQuizzesRouteChildren {
  LearnerCoursesIdQuizzesQuizIdRoute: typeof LearnerCoursesIdQuizzesQuizIdRouteWithChildren
  LearnerCoursesIdQuizzesIndexRoute: typeof LearnerCoursesIdQuizzesIndexRoute
}

const LearnerCoursesIdQuizzesRouteChildren: LearnerCoursesIdQuizzesRouteChildren =
  {
    LearnerCoursesIdQuizzesQuizIdRoute:
      LearnerCoursesIdQuizzesQuizIdRouteWithChildren,
    LearnerCoursesIdQuizzesIndexRoute: LearnerCoursesIdQuizzesIndexRoute,
  }

const LearnerCoursesIdQuizzesRouteWithChildren =
  LearnerCoursesIdQuizzesRoute._addFileChildren(
    LearnerCoursesIdQuizzesRouteChildren,
  )

interface LearnerCoursesIdRouteChildren {
  LearnerCoursesIdAboutRoute: typeof LearnerCoursesIdAboutRoute
  LearnerCoursesIdAssignmentsRoute: typeof LearnerCoursesIdAssignmentsRoute
  LearnerCoursesIdAttendanceRoute: typeof LearnerCoursesIdAttendanceRoute
  LearnerCoursesIdCalendarRoute: typeof LearnerCoursesIdCalendarRoute
  LearnerCoursesIdClassProgressRoute: typeof LearnerCoursesIdClassProgressRouteWithChildren
  LearnerCoursesIdContentRoute: typeof LearnerCoursesIdContentRoute
  LearnerCoursesIdFeedRoute: typeof LearnerCoursesIdFeedRoute
  LearnerCoursesIdGradesRoute: typeof LearnerCoursesIdGradesRoute
  LearnerCoursesIdMyProgressRoute: typeof LearnerCoursesIdMyProgressRoute
  LearnerCoursesIdQuizzesRoute: typeof LearnerCoursesIdQuizzesRouteWithChildren
  LearnerCoursesIdSelfAssessmentsRoute: typeof LearnerCoursesIdSelfAssessmentsRoute
  LearnerCoursesIdSurveysRoute: typeof LearnerCoursesIdSurveysRoute
  LearnerCoursesIdIndexRoute: typeof LearnerCoursesIdIndexRoute
}

const LearnerCoursesIdRouteChildren: LearnerCoursesIdRouteChildren = {
  LearnerCoursesIdAboutRoute: LearnerCoursesIdAboutRoute,
  LearnerCoursesIdAssignmentsRoute: LearnerCoursesIdAssignmentsRoute,
  LearnerCoursesIdAttendanceRoute: LearnerCoursesIdAttendanceRoute,
  LearnerCoursesIdCalendarRoute: LearnerCoursesIdCalendarRoute,
  LearnerCoursesIdClassProgressRoute:
    LearnerCoursesIdClassProgressRouteWithChildren,
  LearnerCoursesIdContentRoute: LearnerCoursesIdContentRoute,
  LearnerCoursesIdFeedRoute: LearnerCoursesIdFeedRoute,
  LearnerCoursesIdGradesRoute: LearnerCoursesIdGradesRoute,
  LearnerCoursesIdMyProgressRoute: LearnerCoursesIdMyProgressRoute,
  LearnerCoursesIdQuizzesRoute: LearnerCoursesIdQuizzesRouteWithChildren,
  LearnerCoursesIdSelfAssessmentsRoute: LearnerCoursesIdSelfAssessmentsRoute,
  LearnerCoursesIdSurveysRoute: LearnerCoursesIdSurveysRoute,
  LearnerCoursesIdIndexRoute: LearnerCoursesIdIndexRoute,
}

const LearnerCoursesIdRouteWithChildren =
  LearnerCoursesIdRoute._addFileChildren(LearnerCoursesIdRouteChildren)

interface LearnerHomeworksIdRouteChildren {
  LearnerHomeworksIdIndexRoute: typeof LearnerHomeworksIdIndexRoute
  LearnerHomeworksIdSubmissionsSidRoute: typeof LearnerHomeworksIdSubmissionsSidRoute
}

const LearnerHomeworksIdRouteChildren: LearnerHomeworksIdRouteChildren = {
  LearnerHomeworksIdIndexRoute: LearnerHomeworksIdIndexRoute,
  LearnerHomeworksIdSubmissionsSidRoute: LearnerHomeworksIdSubmissionsSidRoute,
}

const LearnerHomeworksIdRouteWithChildren =
  LearnerHomeworksIdRoute._addFileChildren(LearnerHomeworksIdRouteChildren)

interface LearnerRouteChildren {
  LearnerAccountRoute: typeof LearnerAccountRoute
  LearnerAnnouncementsRoute: typeof LearnerAnnouncementsRoute
  LearnerAwardsRoute: typeof LearnerAwardsRoute
  LearnerCalendarRoute: typeof LearnerCalendarRoute
  LearnerCoursesRoute: typeof LearnerCoursesRoute
  LearnerHomeworksRoute: typeof LearnerHomeworksRoute
  LearnerMentionsRoute: typeof LearnerMentionsRoute
  LearnerProfileRoute: typeof LearnerProfileRouteWithChildren
  LearnerProgressRoute: typeof LearnerProgressRoute
  LearnerAnnouncementsIdRoute: typeof LearnerAnnouncementsIdRoute
  LearnerCoursesIdRoute: typeof LearnerCoursesIdRouteWithChildren
  LearnerHomeworksIdRoute: typeof LearnerHomeworksIdRouteWithChildren
  LearnerAwardsIdCertificateRoute: typeof LearnerAwardsIdCertificateRoute
}

const LearnerRouteChildren: LearnerRouteChildren = {
  LearnerAccountRoute: LearnerAccountRoute,
  LearnerAnnouncementsRoute: LearnerAnnouncementsRoute,
  LearnerAwardsRoute: LearnerAwardsRoute,
  LearnerCalendarRoute: LearnerCalendarRoute,
  LearnerCoursesRoute: LearnerCoursesRoute,
  LearnerHomeworksRoute: LearnerHomeworksRoute,
  LearnerMentionsRoute: LearnerMentionsRoute,
  LearnerProfileRoute: LearnerProfileRouteWithChildren,
  LearnerProgressRoute: LearnerProgressRoute,
  LearnerAnnouncementsIdRoute: LearnerAnnouncementsIdRoute,
  LearnerCoursesIdRoute: LearnerCoursesIdRouteWithChildren,
  LearnerHomeworksIdRoute: LearnerHomeworksIdRouteWithChildren,
  LearnerAwardsIdCertificateRoute: LearnerAwardsIdCertificateRoute,
}

const LearnerRouteWithChildren =
  LearnerRoute._addFileChildren(LearnerRouteChildren)

interface AdminCoursesIdRouteChildren {
  AdminCoursesIdAssessmentsRoute: typeof AdminCoursesIdAssessmentsRoute
  AdminCoursesIdAttendanceRoute: typeof AdminCoursesIdAttendanceRoute
  AdminCoursesIdAwardsRoute: typeof AdminCoursesIdAwardsRoute
  AdminCoursesIdCurriculumRoute: typeof AdminCoursesIdCurriculumRoute
  AdminCoursesIdEnrollmentsRoute: typeof AdminCoursesIdEnrollmentsRoute
  AdminCoursesIdGradebookRoute: typeof AdminCoursesIdGradebookRoute
  AdminCoursesIdHomeworksRoute: typeof AdminCoursesIdHomeworksRoute
  AdminCoursesIdInfoRoute: typeof AdminCoursesIdInfoRoute
  AdminCoursesIdQuestionsRoute: typeof AdminCoursesIdQuestionsRoute
  AdminCoursesIdQuizzesRoute: typeof AdminCoursesIdQuizzesRoute
  AdminCoursesIdRubricsRoute: typeof AdminCoursesIdRubricsRoute
  AdminCoursesIdSettingsRoute: typeof AdminCoursesIdSettingsRoute
  AdminCoursesIdTeachersRoute: typeof AdminCoursesIdTeachersRoute
  AdminCoursesIdIndexRoute: typeof AdminCoursesIdIndexRoute
  AdminCoursesIdAssessmentsQuizIdEditRoute: typeof AdminCoursesIdAssessmentsQuizIdEditRoute
  AdminCoursesIdQuizzesQuizIdEditRoute: typeof AdminCoursesIdQuizzesQuizIdEditRoute
  AdminCoursesIdQuizzesQuizIdStatisticsRoute: typeof AdminCoursesIdQuizzesQuizIdStatisticsRoute
}

const AdminCoursesIdRouteChildren: AdminCoursesIdRouteChildren = {
  AdminCoursesIdAssessmentsRoute: AdminCoursesIdAssessmentsRoute,
  AdminCoursesIdAttendanceRoute: AdminCoursesIdAttendanceRoute,
  AdminCoursesIdAwardsRoute: AdminCoursesIdAwardsRoute,
  AdminCoursesIdCurriculumRoute: AdminCoursesIdCurriculumRoute,
  AdminCoursesIdEnrollmentsRoute: AdminCoursesIdEnrollmentsRoute,
  AdminCoursesIdGradebookRoute: AdminCoursesIdGradebookRoute,
  AdminCoursesIdHomeworksRoute: AdminCoursesIdHomeworksRoute,
  AdminCoursesIdInfoRoute: AdminCoursesIdInfoRoute,
  AdminCoursesIdQuestionsRoute: AdminCoursesIdQuestionsRoute,
  AdminCoursesIdQuizzesRoute: AdminCoursesIdQuizzesRoute,
  AdminCoursesIdRubricsRoute: AdminCoursesIdRubricsRoute,
  AdminCoursesIdSettingsRoute: AdminCoursesIdSettingsRoute,
  AdminCoursesIdTeachersRoute: AdminCoursesIdTeachersRoute,
  AdminCoursesIdIndexRoute: AdminCoursesIdIndexRoute,
  AdminCoursesIdAssessmentsQuizIdEditRoute:
    AdminCoursesIdAssessmentsQuizIdEditRoute,
  AdminCoursesIdQuizzesQuizIdEditRoute: AdminCoursesIdQuizzesQuizIdEditRoute,
  AdminCoursesIdQuizzesQuizIdStatisticsRoute:
    AdminCoursesIdQuizzesQuizIdStatisticsRoute,
}

const AdminCoursesIdRouteWithChildren = AdminCoursesIdRoute._addFileChildren(
  AdminCoursesIdRouteChildren,
)

interface AdminRouteChildren {
  AdminAccountRoute: typeof AdminAccountRoute
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminAwardsRoute: typeof AdminAwardsRoute
  AdminCalendarRoute: typeof AdminCalendarRoute
  AdminCoursesRoute: typeof AdminCoursesRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminGbReportCardsRoute: typeof AdminGbReportCardsRoute
  AdminMarkSchemesRoute: typeof AdminMarkSchemesRoute
  AdminStudentsRoute: typeof AdminStudentsRoute
  AdminSubjectsRoute: typeof AdminSubjectsRoute
  AdminTeachersRoute: typeof AdminTeachersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCoursesIdRoute: typeof AdminCoursesIdRouteWithChildren
  AdminGbReportCardsIdRoute: typeof AdminGbReportCardsIdRoute
  AdminGbReportCardsIdPrintRoute: typeof AdminGbReportCardsIdPrintRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAccountRoute: AdminAccountRoute,
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminAwardsRoute: AdminAwardsRoute,
  AdminCalendarRoute: AdminCalendarRoute,
  AdminCoursesRoute: AdminCoursesRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminGbReportCardsRoute: AdminGbReportCardsRoute,
  AdminMarkSchemesRoute: AdminMarkSchemesRoute,
  AdminStudentsRoute: AdminStudentsRoute,
  AdminSubjectsRoute: AdminSubjectsRoute,
  AdminTeachersRoute: AdminTeachersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCoursesIdRoute: AdminCoursesIdRouteWithChildren,
  AdminGbReportCardsIdRoute: AdminGbReportCardsIdRoute,
  AdminGbReportCardsIdPrintRoute: AdminGbReportCardsIdPrintRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LearnerRoute: LearnerRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
